import { EPermissionType } from '@/interfaces'

export const enum EDocTypes {
  CITIZEN_CARD = 'cc',
  PASSPORT = 'passport',
}

export const DOC_TYPES_OPTIONS = [
  {
    label: 'Cédula de Ciudadanía',
    value: EDocTypes.CITIZEN_CARD,
  },
  {
    label: 'Pasaporte',
    value: EDocTypes.PASSPORT,
  },
]

export const PERMISSION_TYPES_OPTIONS = [
  {
    label: 'Validación de Datos',
    value: EPermissionType.DATA,
  },
  {
    label: 'Validación Visual',
    value: EPermissionType.VIEW,
  },
  {
    label: 'Acceso a Rutas',
    value: EPermissionType.ROUTE,
  },
]
